import styled from '@emotion/styled';
import { H3 } from 'ds/components/typography';

export const Wrapper = styled.div`
  max-width: 354px;
  width: 100%;
  overflow: hidden;
  border-radius: 24px;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  position: fixed;
  bottom: 24px;
  right: 24px;
  box-shadow: ${({ theme }) => theme.shadow.level7};
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(3)}`};
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    left: 24px;
    max-width: unset;
    right: 24px;
    width: auto;
  `}
  z-index: 99999;
  direction: rtl;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: start;
`;

export const ImgWrapper = styled.div`
  font-size: 48px;
  line-height: 48px;
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

export const TextWrapper = styled(H3.withComponent('span'))`
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  max-width: 280px;
  & * {
    display: inline-block;
  }
`;
